import { render, staticRenderFns } from "./ChargerTabs.vue?vue&type=template&id=b4c2c4e8&scoped=true&"
import script from "./ChargerTabs.vue?vue&type=script&lang=js&"
export * from "./ChargerTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c2c4e8",
  null
  
)

export default component.exports